import jwtDecode from "jwt-decode";
import { authApi } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import storeService from "../../../../helper/store";
import { Credentials, Token } from "../entity/auth.model";

function login(credentials: Credentials): Promise<Token> {
  let data = new URLSearchParams();
  data.append("username", credentials.username);
  data.append("password", credentials.password);
  data.append("grant_type", mConstants.GRANT_TYPE);
  data.append("client_id", mConstants.CLIENT_ID);

  return authApi
    .post(
      `/ma/realms/${mConstants.REALM}/protocol/openid-connect/token`,
      data,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
    .then((token: any) => {
      storeService.setToken(token);
      storeService.setUser(jwtDecode(token.access_token));
      return Promise.resolve(token);
    });
}

function logout() {
  storeService.clear();
  window.location.href = "/auth/login";
}

export const authService = {
  login,
  logout
};
